import { render, staticRenderFns } from "./newsSwiperList.vue?vue&type=template&id=7217767e&scoped=true&"
import script from "./newsSwiperList.vue?vue&type=script&lang=js&"
export * from "./newsSwiperList.vue?vue&type=script&lang=js&"
import style0 from "./newsSwiperList.vue?vue&type=style&index=0&id=7217767e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7217767e",
  null
  
)

export default component.exports